import app from 'flarum/app';
import {extend, override} from 'flarum/extend';
import DiscussionControls from 'flarum/utils/DiscussionControls';
import Alert from 'flarum/components/Alert';
import Button from 'flarum/components/Button';
import CommentPost from 'flarum/components/CommentPost';

import Post from 'flarum/models/Post';
import Model from 'flarum/Model';
import ReplyComposer from "flarum/components/ReplyComposer";
import LogInModal from "flarum/components/LogInModal";

import NotificationGrid from 'flarum/components/NotificationGrid';
import { getPlainContent } from 'flarum/utils/string';

import addPostMentionPreviews from './addPostMentionPreviews';
import addMentionedByList from './addMentionedByList';
import addPostReplyAction from './addPostReplyAction';
import addPostQuoteButton from './addPostQuoteButton';
import addComposerAutocomplete from './addComposerAutocomplete';
import PostMentionedNotification from './components/PostMentionedNotification';
import UserMentionedNotification from './components/UserMentionedNotification';
import UserPage from 'flarum/components/UserPage'
import LinkButton from 'flarum/components/LinkButton';
import MentionsUserPage from './components/MentionsUserPage';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

import MakeTree from './MakeTree';

app.initializers.add('kyrne-everygreen', () => {
  Post.prototype.replyTo = Model.attribute('replyTo');
  Post.prototype.replyCount = Model.attribute('replyCount');
  Post.prototype.replyPost = Model.attribute('replyPost');
  Post.prototype.contentLang = Model.attribute('contentLang');

  DiscussionControls.replyAction = function (goToLast, forceRefresh, replyTo, replyPost) {
    return new Promise((resolve, reject) => {
      if (app.session.user) {
        if (this.canReply()) {
          if (!app.composer.composingReplyTo(this) || forceRefresh) {
            app.composer.load(ReplyComposer, {
              user: app.session.user,
              discussion: this,
              replyTo,
              replyPost
            });                                                  
          }
          app.composer.show();

          if (goToLast && app.viewingDiscussion(this) && !app.composer.isFullScreen()) {
            // app.current.get('stream').goToNumber('reply');
          }

          return resolve(app.composer);
        } else {
          return reject();
        }
      }

      app.modal.show(LogInModal);

      return reject();
    });
  };

  extend(ReplyComposer.prototype, 'oninit', function() {
    this.replyTo = this.attrs.replyTo;
    this.replyPost = this.attrs.replyPost;
  });

  extend(ReplyComposer.prototype, 'data', function(data) {
    data.replyTo = this.replyTo
    data.replyPost = this.replyPost
    // let isLoading = this.attrs.discussion.pkgActivity() ? this.attrs.discussion.pkgActivity()?.isLoading() : false
    // if (this.attrs.discussion.pkgActivity()) {
      // if (isLoading && !this.replyTo) {
      //   data.isJoin = 1
      // }
    // }
    
  });

  override(ReplyComposer.prototype, 'onsubmit', function() {
    const discussion = this.attrs.discussion;
    const data = this.data();
    this.loading = true;
    if (!data.content || data.content == '0' || data.content.trim() == "") {
      this.loading = false;
      AlertUtil.onWarn(app, app.translator.trans('dl-alert.forum.content_empty_warn'));
      return;
    }

    //猜谜活动
    if (app.forum.attribute('guessGameStatus') && discussion.isGuessGame()) {
      // app.data['GuessGameRole'] = app.store.all('guessGame');
      const cleanedValue = data.content.trim().replace(/[\n\t\r]/g, '');
      if (cleanedValue === discussion.guessText()) {
        app.composer.hide();
        const url = app.route('puzzle', { type: 'postPuzzleed', isOpen: app.data['GuessGameRole'] != null});
        setTimeout(() => {
          m.route.set(url)
        }, 200);
        return
      }
    }
    
    //TODO-判断是否存在限制，从限制列表中获取，如果存在强限制，不符合要求需提醒，否则不需提醒
    if (data.isJoin) {
      let pkgActivity = app.store.getById('pkgActivityCategories', data.activityId);
      let limitList = JSON.parse(pkgActivity.limitList());
      for (let index = 0; index < limitList.length; index++) {
        const element = limitList[index];
        if (element.strongLimit) {
          if (element.type== '0' && data.content.length < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.numberStr',{count: element.param}));
            return;
          }
          //带图数
          // 使用正则表达式匹配 <img> 标签
          const imgTags = data.content.match(/\[Image description\]/g);

          // 计算匹配到的 <img> 标签数量
          const imgCount = imgTags ? imgTags.length : 0;
          if (element.type== '1' && imgCount < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.imgCount',{count: element.param}));
            return;
          }
          
          //论坛等级
          if (element.type== '2' && app.session.user.userLevel().level() < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.level',{count: element.param}));
            return;
          }
         
        }
      }
    }
    // m.redraw();

    app.store
      .createRecord('posts')
      .save(data)
      .then(async (post) => {
        if (this.draft) {
          this.draft.delete();
        }
        // 确保帖子在 store 中
        if (!app.store.getById('posts', post.id())) {
          console.warn('帖子不在 store 中，尝试添加');
          app.store.pushPayload({ data: post.data });
        }
        // If we're currently viewing the discussion which this reply was made
        // in, then we can update the post stream and scroll to the post.
        if (app.viewingDiscussion(discussion)) {
          
          if (this.attrs.replyTo) {
            app.cache.trees[this.attrs.replyTo].push(post);
            app.cache.pushTree[this.attrs.replyTo]++;
          } else {
            const stream = app.current.get('stream');

            // 先刷新 discussion 的评论数量
            discussion.pushAttributes({
              commentCount: (discussion.commentCount() || 0) + 1,
            });
            // 直接将新帖子插入到流中，而不是重新加载
            const insertedIndex = stream.insertPost(post);
            
            // 如果插入成功，触发界面更新
            if (insertedIndex >= 0) {
              m.redraw();
            }
          }
        } else {
          // Otherwise, we'll create an alert message to inform the user that
          // their reply has been posted, containing a button which will
          // transition to their new post when clicked.
          let alert;
          const viewButton = Button.component(
            {
              className: 'Button Button--link',
              onclick: () => {
                m.route.set(app.route.post(post));
                app.alerts.dismiss(alert);
              },
            },
            app.translator.trans('core.forum.composer_reply.view_button')
          );
          alert = app.alerts.show(
            {
              type: 'success',
              controls: [viewButton],
            },
            app.translator.trans('core.forum.composer_reply.posted_message')
          );
        }
        app.composer.hide();
        
      })
      .catch(async (response) => {
        if (response.status == 422) {
          m.route.set(app.route.discussion(discussion));
        }
        this.loading = false;
        app.composer.hide();
        m.redraw();
      });
  });

  // For every mention of a post inside a post's content, set up a hover handler
  // that shows a preview of the mentioned post.
  addPostMentionPreviews();

  // In the footer of each post, show information about who has replied (i.e.
  // who the post has been mentioned by).
  addMentionedByList();

  // Add a 'reply' control to the footer of each post. When clicked, it will
  // open up the composer and add a post mention to its contents.
  addPostReplyAction();

  // Show a Quote button when Post text is selected
  addPostQuoteButton();

  // After typing '@' in the composer, show a dropdown suggesting a bunch of
  // posts or users that the user could mention.
  addComposerAutocomplete();

  MakeTree();

  app.notificationComponents.postMentioned = PostMentionedNotification;
  app.notificationComponents.userMentioned = UserMentionedNotification;

  // Add notification preferences.
  extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
    // items.add('postMentioned', {
    //   name: 'postMentioned',
    //   icon: 'fas fa-reply',
    //   label: app.translator.trans('flarum-mentions.forum.settings.notify_post_mentioned_label')
    // });

    items.add('userMentioned', {
      name: 'userMentioned',
      icon: 'fas fa-at',
      label: app.translator.trans('flarum-mentions.forum.settings.notify_user_mentioned_label')
    });
  });

  // Add mentions tab in user profile
  app.routes['user.mentions'] = {path: '/user/:username/mentions', component: MentionsUserPage};
  extend(UserPage.prototype, 'navItems', function(items) {
    const user = this.user;
    items.add('mentions',
      LinkButton.component({
        href: app.route('user.mentions', {username: user.slug()}),
        name: 'mentions',
        icon: 'fas fa-at'
      }, app.translator.trans('flarum-mentions.forum.user.mentions_link')),
      80
    );
  });

  // Remove post mentions when rendering post previews.
  getPlainContent.removeSelectors.push('a.PostMention');
});

export * from './utils/textFormatter';